var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.8438 44.2051V82.2422C81.8437 84.7286 80.856 87.1132 79.0979 88.8713C77.3397 90.6295 74.9552 91.6172 72.4688 91.6172H28.7188C26.2323 91.6172 23.8478 90.6295 22.0896 88.8713C20.3315 87.1132 19.3438 84.7286 19.3438 82.2422V19.7422C19.3438 17.2558 20.3315 14.8712 22.0896 13.1131C23.8478 11.3549 26.2323 10.3672 28.7188 10.3672H48.0059C49.6629 10.3674 51.252 11.0257 52.4238 12.1973L80.0137 39.7871C81.1852 40.9589 81.8435 42.548 81.8438 44.2051Z",
    stroke: "#9C4900",
    strokeWidth: 6.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5938 11.9297V35.3672C50.5937 37.0248 51.2522 38.6145 52.4243 39.7866C53.5964 40.9587 55.1861 41.6172 56.8438 41.6172H80.2812",
    stroke: "#9C4900",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigSave);
export default __webpack_public_path__ + "static/media/bigSave.0edfc30ff8be51004e685ddbedd638df.svg";
export { ForwardRef as ReactComponent };